import type { SceneNodeItem } from "../scene/SceneNodeItem";
import type { SceneTreeNode } from "../scene/SceneTreeItem";

/**
 * Type guard to check if a SceneNodeItem is of dataType "group"
 */
export function isSceneGroupNode(node: SceneNodeItem): node is SceneNodeItem<"group"> {
  return node.dataType === "group";
}

export function isGroupTreeNode(treeNode: SceneTreeNode): treeNode is SceneTreeNode<"group"> {
  return treeNode.node.dataType === "group";
}
